import { useCallback } from 'react';

/**
 * FE-FIX02. У каждой вкладки раздела свой набор фильтров в URL. Переключение
 * вкладок раньше стирало их полностью (`setSearchParams({ tab })`), а возврат
 * на вкладку открывал её пустой.
 *
 * Кэш живёт в sessionStorage, а не в памяти компонента: вкладка размонтируется
 * при переключении, и состояние в useState умирает вместе с ней. URL при этом
 * остаётся authoritative — восстановление происходит только по клику на
 * вкладку, поэтому Back/Forward не подмешивает чужое состояние.
 *
 * Ключ включает логин: за одной сессией браузера могут работать разные
 * пользователи, и фильтр по недоступному им заводу не должен всплыть.
 */
const PREFIX = 'violations';

const currentUserKey = () => {
  try {
    return localStorage.getItem('auth_email') || 'anonymous';
  } catch (error) {
    return 'anonymous';
  }
};

const storageKey = (tabId, userKey) => `${PREFIX}:${tabId}:${userKey}`;

export const useTabFilterCache = () => {
  const saveTabParams = useCallback((tabId, searchParams) => {
    const next = new URLSearchParams(searchParams);
    next.delete('tab');
    const serialized = next.toString();

    try {
      const key = storageKey(tabId, currentUserKey());
      if (serialized) sessionStorage.setItem(key, serialized);
      else sessionStorage.removeItem(key);
    } catch (error) {
      // Приватный режим / запрет на storage — фильтры просто не переживут
      // переключение вкладки, но страница обязана работать.
    }
  }, []);

  const restoreTabParams = useCallback((tabId) => {
    try {
      return new URLSearchParams(sessionStorage.getItem(storageKey(tabId, currentUserKey())) || '');
    } catch (error) {
      return new URLSearchParams();
    }
  }, []);

  return { saveTabParams, restoreTabParams };
};

export default useTabFilterCache;
